
import { Component, Prop, Vue } from "vue-property-decorator";
import { SingleChargePickerModel } from "./SingleChargePickerModel";
import { getChargeOptions } from "../service/ChargeService";
import FillerPicker from "./FillerPicker.vue";
import StripDetailsEditor from "./strip/StripDetailsEditor.vue";
import StripMainEditor from "./strip/StripMainEditor.vue";
import StripCompanionEditor from "./strip/StripCompanionEditor.vue";
import { MyOption } from "../service/MyOptions.type";
import { v4 as uuidv4 } from "uuid";

@Component({
  components: {
    FillerPicker,
    StripMainEditor,
    StripDetailsEditor,
    StripCompanionEditor,
  },
})
export default class SingleChargePicker extends Vue {
  @Prop() value!: SingleChargePickerModel;

  chargeOptions: MyOption[] = [];
  uuid = uuidv4();
  showStripDetails = false;
  showStripComponionDetails = false;

  async created(): Promise<void> {
    this.chargeOptions = await getChargeOptions();
  }

  switchStripDetails(): void {
    this.showStripDetails = !this.showStripDetails;
  }

  switchStripCompanionDetails(): void {
    this.showStripComponionDetails = !this.showStripComponionDetails;
  }

  update(): void {
    this.$emit("input", this.value);
  }
}
